import { Controller } from "@hotwired/stimulus";
import { debugLog } from "../utils";

// Counts down the window a locked exchange rate stays spendable, and takes the
// confirm button away when it runs out.
//
// The seconds come from the server rather than from an expiry timestamp on
// purpose: the customer's clock is not ours, and a quote that looks valid for
// another minute on a device running two minutes slow is a failed withdrawal
// and a support ticket. A duration is the same on every clock.
export default class extends Controller {
  static targets = ["countdown", "live", "expired", "confirmButton"];
  static values = { seconds: Number };

  connect() {
    debugLog("QuoteTimerController: Connected");
    this.remaining = Number(this.secondsValue) || 0;

    if (this.remaining <= 0) {
      this.expire();
      return;
    }

    this.render();
    this.ticker = setInterval(() => this.tick(), 1000);
  }

  // Stimulus reconnects a controller whenever Turbo swaps the frame it lives
  // in, so an interval left running here would keep ticking against a detached
  // element and stack up on every visit.
  disconnect() {
    this.stop();
  }

  tick() {
    this.remaining -= 1;

    if (this.remaining <= 0) {
      this.expire();
      return;
    }

    this.render();
  }

  render() {
    if (!this.hasCountdownTarget) {
      return;
    }

    this.countdownTarget.textContent = `${this.remaining}s`;

    // The last ten seconds are the only moment the timer is worth looking at.
    this.countdownTarget.classList.toggle("text-red-500", this.remaining <= 10);
  }

  expire() {
    this.stop();
    this.remaining = 0;

    if (this.hasLiveTarget) {
      this.liveTarget.classList.add("hidden");
      this.liveTarget.classList.remove("flex");
    }
    if (this.hasExpiredTarget) {
      this.expiredTarget.classList.remove("hidden");
      this.expiredTarget.classList.add("flex");
    }

    // Submitting now would send Walapay a quote they have already released, so
    // the button is disabled rather than left to fail at the API.
    if (this.hasConfirmButtonTarget) {
      const button = this.confirmButtonTarget;
      button.disabled = true;
      button.classList.add("opacity-50", "cursor-not-allowed", "pointer-events-none");
    }
  }

  stop() {
    if (this.ticker) {
      clearInterval(this.ticker);
      this.ticker = null;
    }
  }
}
